import { MUTE_MEETING_AUDIO } from 'actions/Types';

export default muteMeetingAudio => {
  return dispatch => {
    const action = {
      type: MUTE_MEETING_AUDIO,
      payload: muteMeetingAudio
    };

    dispatch(action);
  };
};
